import { AllocationHeaderRowType } from "../../../repertoire/types/usageTypes/IAllocationRowTypes";

export function getAllocationRows(result: any): any[] {
    if (Array.isArray(result)) {
        return result;
    }

    return result?.rows ?? result?.Rows ?? [];
}

export function mapAllocationRow(allocation: any, index: number): AllocationHeaderRowType {
    return {
        key: index,
        AllocationUsageHeaderId: allocation.AllocationUsageHeaderID ?? '',
        PoolCode: allocation.PoolCode ?? '',
        WorkNumber: allocation.WorkNumber ?? '',
        WorkName: allocation.WorkName ?? '',
        ProductNumber: allocation.ProductNumber ?? '',
        AllocationDate: allocation.AllocationDate ?? '',
        AllocationWeight: allocation.AllocationWeight ? Number(allocation.AllocationWeight).toString() : '',
        TotalAmount: allocation.TotalAmount ? Number(allocation.TotalAmount).toString() : '',
        UsageDetails: allocation.usage_detail
            ? JSON.parse(allocation.usage_detail).map(x => ({ ...x, PoolCode: allocation.PoolCode }))
            : [],
        IsSelected: false,
        UsageGroupID: allocation.UsageGroupID ?? ''
    };
}